<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-data-table :headers="headers" :items="accounts" @click:row="goto" :loading="accountsLoading">
              <template v-slot:item.account_id="{ item }"><span class="body--text">{{ item.account_id }}</span></template>
              <template v-slot:item.business_name="{ item }"><span class="body--text">{{ item.business_name }}</span></template>
              <template v-slot:item.customer_name="{ item }"><span class="body--text">{{ formatName(item.customer_name) }}</span></template>
              <template v-slot:item.email_address="{ item }"><span class="body--text">{{ item.email_address }}</span></template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    headers: [
      {
        text: "Id",
        align: "left",
        sortable: true,
        value: "account_id"
      },
      {
        text: "Business Name",
        align: "left",
        sortable: false,
        value: "business_name"
      },
      {
        text: "Customer Name",
        align: "left",
        sortable: false,
        value: "customer_name"
      },
      {
        text: "Customer Email",
        align: "left",
        sortable: false,
        value: "email_address"
      }
    ]
  }),
  computed: {
    ...mapState("accounts", ["accounts","accountsLoading"])
  },
  methods: {
    formatName(name){
      return name.toLowerCase().split(' ').filter(Boolean).map(str => str[0].toUpperCase() + str.slice(1, str.length)).join(' ');
    },
    goto(e){ this.$router.push(`/accounts/${e.account_id}/`); }
  },
  mounted(){}
};
</script>

<style lang="scss" scoped>
  .v-data-table ::v-deep tbody tr {
    cursor: pointer !important;
  }
</style>
